import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Slick } from 'ngx-slickjs';
import { AllapiService } from '../allapi.service';
import { Subscription } from 'rxjs';
import { MatchService } from '../common-service/match.service';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  thumbnail;
  allNews: any = [];
  imgUrl: any;
  imgUrl2: any;
  // productservices: any;
  allVideo: any = [];
  mainVideo: any = [];
  videoUrl: SafeResourceUrl;
  // productservices2: any;
  allPhotos: any = [];
  // productservices3: any;

  event_list: any = [];
  past_events: any = [];
  // productservices4: any;
  imageObjectData: any = [];
  imageObject: any = [];
  // productservices1: any;
  partnersObject: any = {};
  // isCountDownStart: boolean = true;
  countdown: any = undefined;
  countdownText: any = undefined;
  startMatchDate: any;
  deviceStatus: string = 'lg';
  sub1: Subscription | undefined = undefined;
  sub2: Subscription | undefined = undefined;
  sub3: Subscription | undefined = undefined;
  sub4: Subscription | undefined = undefined;

  sub7: Subscription | undefined = undefined;
  sub8: Subscription | undefined = undefined;
  liveMatch: any = [];
  allPoints: any = [];
  sub5: Subscription | undefined = undefined;
  sub6: Subscription | undefined = undefined;
  intervalTime: any = undefined;
  totalBoundaryCount: any[] = [];
  constructor(private server: AllapiService, private sanitizer: DomSanitizer, private datePipe: DatePipe,
    private matchService: MatchService, private router: Router) {
    this.imgUrl = this.server.dashboardSlider;
    this.imgUrl2 = this.server.mediaNews;
    this.fetchSlider();
    this.fetchallVideo();
    // this.fetchPartner();
  }
  ngOnInit() {
    this.getInnerHeight();
    this.liveApiMatch();
    this.matchCenter();
    this.pointTable();
    // this.getjsondataOnlyResult();
    // this.getjsondataOnlyStandings();
    this.fetchPhots();
    this.fetchallNews();
    // ==========Polling=======
    // if (this.intervalTime) {
    //   clearInterval(this.intervalTime);
    // }
    // this.intervalTime = setInterval(() => {
    //   this.liveApiMatch();
    // }, 20000);
    this.boundaryCount();
  }
  getInnerHeight(): void {
    this.deviceStatus = this.server.checkSystemWidth();
    console.log('this.deviceStatus :>> ', this.deviceStatus);
  }
  // countDownTimer(): void { //todo
  //   if (this.isCountDownStart) {
  //     this.countdownText = {};
  //     this.startMatchDate = this.formatDate(new Date(Date.UTC(2023, 6, 20, 19, 30, 0)));
  //     // Set the target date in Eastern Daylight Time (EDT) - America/Toronto
  //     const countDownDate = new Date(Date.UTC(2023, 6, 20, 19, 30, 0));
  //     // const countDownDate = new Date("May 20, 2023 21:26:00").getTime();
  //     this.countdown = setInterval(() => {
  //       const now = new Date().getTime();
  //       let distance = countDownDate.getTime() - now;

  //       let days = Math.floor(distance / (1000 * 60 * 60 * 24));
  //       let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  //       let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  //       let seconds = Math.floor((distance % (1000 * 60)) / 1000);

  //       this.countdownText = {
  //         "days": days.toString().padStart(2, '0'),
  //         "hours": hours.toString().padStart(2, '0'),
  //         "minutes": minutes.toString().padStart(2, '0'),
  //         "seconds": seconds.toString().padStart(2, '0'),
  //       }

  //       if (distance < 0) {
  //         clearInterval(this.countdown);
  //         this.isCountDownStart = false;
  //         console.log('"The countdown is over!" :>> ');
  //         this.countdownText = undefined;
  //       }
  //     }, 1000);
  //   }//else{NOT REQUIRED}
  // }
  fetchSlider() {
    this.sub1 = this.server.getApi('G8').subscribe((res) => {
      if (res.responseCode == 200) {
        this.event_list = res.response;
        if (this.event_list.length > 0) {
          // this.past_events = this.event_list.filter(event => new Date(event.eventEndingDate) < new Date());
          this.past_events = this.event_list.reverse();
        } else {
          this.past_events = [];
        }
      } else {
        this.event_list = undefined;
        this.past_events = [];
      }
      // event_list = [
      //   {
      //     img: 'https://gt20webstorage.s3.ap-south-1.amazonaws.com/gt20website/images/slider/1.png',
      //     eventEndingDate: new Date('2018/05/24')
      //   },
      //   {
      //     img: 'https://gt20webstorage.s3.ap-south-1.amazonaws.com/gt20website/images/slider/2.png',
      //     eventEndingDate: new Date('2018/05/24')
      //   },
      //   {
      //     img: 'https://gt20webstorage.s3.ap-south-1.amazonaws.com/gt20website/images/slider/3.png',
      //     eventEndingDate: new Date('2018/05/24')
      //   },
      //   // {
      //   //   img: 'https://gt20webstorage.s3.ap-south-1.amazonaws.com/gt20website/images/slider/1.jpg',
      //   //   eventEndingDate: new Date('2018/05/24')
      //   // }
      // ]
      // past_events = this.event_list.filter(event => event.eventEndingDate < new Date());
    });
    // this.countDownTimer();
  }
  // config: Slick.Config = {
  //   infinite: true,
  //   slidesToShow: 4,
  //   slidesToScroll: 1,
  //   dots: false,
  //   autoplay: false,
  //   autoplaySpeed: 500
  // }
  // fetchPartner() {
  //   this.server.getApi('G9').subscribe((res) => {
  //     this.imageObjectData = res.response;

  //     // forLooop Method
  //     // for (let data of this.imageObjectData) {
  //     //   this.partnersObject = {}
  //     //   Object.assign(this.partnersObject, { "image": this.imgUrl + data.image })
  //     //   Object.assign(this.partnersObject, { "thumbImage": this.imgUrl + data.thumbImage })
  //     //   this.imageObject.push(this.partnersObject);
  //     // }

  //     // foreachMethod
  //     // this.imageObjectData.forEach((element, index) => {
  //     //   this.partnersObject = {}
  //     //   Object.assign(this.partnersObject, { "index": index + 1 })
  //     //   Object.assign(this.partnersObject, { "image": this.imgUrl + element.image })
  //     //   Object.assign(this.partnersObject, { "thumbImage": this.imgUrl + element.thumbImage })
  //     //   this.imageObject.push(this.partnersObject);
  //     // });
  //     // console.log(this.imageObject)

  //     // imageObject = [{
  //     //   image: 'https://gt20webstorage.s3.ap-south-1.amazonaws.com/gt20website/images/partners/2.png',
  //     //   thumbImage: 'https://gt20webstorage.s3.ap-south-1.amazonaws.com/gt20website/images/partners/2.png',
  //     // }, {
  //     //   image: 'https://gt20webstorage.s3.ap-south-1.amazonaws.com/gt20website/images/partners/1.jpg',
  //     //   thumbImage: 'https://gt20webstorage.s3.ap-south-1.amazonaws.com/gt20website/images/partners/1.jpg'
  //     // }, {
  //     //   image: 'https://gt20webstorage.s3.ap-south-1.amazonaws.com/gt20website/images/partners/11.png',
  //     //   thumbImage: 'https://gt20webstorage.s3.ap-south-1.amazonaws.com/gt20website/images/partners/11.png',
  //     // }, {
  //     //   image: 'https://gt20webstorage.s3.ap-south-1.amazonaws.com/gt20website/images/partners/4.png',
  //     //   thumbImage: 'https://gt20webstorage.s3.ap-south-1.amazonaws.com/gt20website/images/partners/4.png',
  //     // }, {
  //     //   image: 'https://gt20webstorage.s3.ap-south-1.amazonaws.com/gt20website/images/partners/5.png',
  //     //   thumbImage: 'https://gt20webstorage.s3.ap-south-1.amazonaws.com/gt20website/images/partners/5.png'
  //     // }, {
  //     //   image: 'https://gt20webstorage.s3.ap-south-1.amazonaws.com/gt20website/images/partners/6.png',
  //     //   thumbImage: 'https://gt20webstorage.s3.ap-south-1.amazonaws.com/gt20website/images/partners/6.png',
  //     // }];
  //   })
  // }
  directionleft: boolean = true;
  directionright: boolean = false;
  value: any;
  owlclick(direction) {
    if (direction == 'left') {
      this.value = 'left';
      this.directionleft = true;
      this.directionright = false;

    }
    if (direction == 'right') {
      this.value = 'right';
      this.directionright = true;
      this.directionleft = false;
    }

  }
  fetchallVideo() {
    this.sub2 = this.server.getApi('G5').subscribe((res) => {
      if (res.responseCode == 200) {
        this.allVideo = res.response
        this.mainVideo = [];
        for (let data of this.allVideo) {
          this.videoUrl = {}
          Object.assign(this.videoUrl, { "video_Url": this.sanitizer.bypassSecurityTrustResourceUrl(data.video_Url) })
          Object.assign(this.videoUrl, { "video_Title": data.video_Title })
          Object.assign(this.videoUrl, { "video_Image": data.video_ImageUrl })
          Object.assign(this.videoUrl, { "imgShow": true })
          Object.assign(this.videoUrl, { "videoShow": false })
          this.mainVideo.push(this.videoUrl);
        }
      }
    })
  }
  fetchPhots() {
    this.sub3 = this.server.getApi('G4').subscribe((res) => {
      if (res.responseCode == 200) {
        this.allPhotos = res.response;
      } else {
      }
    })
  }
  fetchallNews() {
    this.sub4 = this.server.getApi('G2').subscribe((res) => {
      if (res.responseCode == 200) {
        this.allNews = res.response;
      }
    })
  }
  imgId: any;
  openIframe(data) {
    this.imgId = data.video_Image;
    for (let allVideodata of this.mainVideo) {
      if (allVideodata.video_Image == this.imgId) {
        allVideodata.imgShow = false;
        allVideodata.videoShow = true;
      }
    }
  }
  // -------------------------------
  standingData: boolean = true;
  playoff: boolean = false;
  actionName: any = 'Standings'
  Selected(action) {
    if (action == 'Standings') {
      this.actionName = action;
      this.standingData = true;
      this.playoff = false;
    }
    if (action == 'Playoffs') {
      this.actionName = action;
      this.playoff = true;
      this.standingData = false;

    }
  }
  allResult: any = []
  // getjsondataOnlyResult() {
  //   this.server.getjsonData('results/results_2019.json').subscribe(data => {
  //     this.allResult = data['matchsummary'];
  //     // // ========NEW RESPONSE JMV===============
  //     //     {
  //     //       "match_id": 466015,
  //     //       "type": 2,
  //     //       "match_date_time": "2019-12-05T12:14:00.000Z",
  //     //       "status": "upcoming",
  //     //       "team_a_id": 362508,
  //     //       "team_a_name": "India (WC19)",
  //     //       "team_b_id": 362504,
  //     //       "team_b_name": "England (WC19)",
  //     //       "match_result": "",
  //     //       "win_by": "",
  //     //       "winning_team_id": "",
  //     //       "winning_team": ""
  //     //     }
  //     //   ]
  //     // }
  //     // this.allResult = [];
  //     // response.data.forEach(element => {
  //     //   // check firefox
  //     //   const date = new Date(element.match_date_time);
  //     //   const day = date.getDate();
  //     //   const year = date.getFullYear();
  //     //   const month = date.toLocaleString('default', { month: 'short' }); // Get the short month name
  //     //   const formattedDate = `${day} ${month} ${year}`;
  //     //   let format = {
  //     //     ...element,
  //     //     'MatchDate': formattedDate,
  //     //     'GroundName': '',
  //     //     'HomeTeamLogo': '',
  //     //     'AwayTeamLogo': '',
  //     //     'FirstBattingTeamName': element.team_a_name,
  //     //     'SecondBattingTeamName': element.team_b_name,
  //     //     'Comments': (element.winning_team + ' Won By ' + element.win_by)
  //     //   }
  //     //   this.allResult.push(format);
  //     // });
  //     // // ========NEW RESPONSE JMV===============
  //     console.log('this.allResult :>> ', this.allResult);
  //   });
  // }
  matchResult: Slick.Config = {
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    autoplay: false,
    autoplaySpeed: 2000
  }

  // getjsondataOnlyStandings() {
  //   this.server.getjsonData('standings/2019.json').subscribe(data => {
  //     this.allPoints = data['points'];
  //     console.log('this.allPoints :>> ', this.allPoints);
  //   });
  // }
  // ==============New Api data===============
  private pointTable(): void {
    let url = '/thirdparty/gt20/get-tournament-point-table/' + this.matchService.tournamentId;
    this.sub5 = this.matchService.makeApiRequest(url).subscribe((response: any) => {
      if (response.status) {
        this.allPoints = response.data;
      } else {
        this.allPoints = [];
      }
    }, error => {
      // Handle errors
      this.allPoints = [];
      console.error(error);
    });
  }
  private matchCenter(): void {
    let url = '/thirdparty/gt20/get-tournament-match-list/' + this.matchService.tournamentId + '?type=3&order=DESC';
    this.sub6 = this.matchService.makeApiRequest(url).subscribe((response: any) => {
      if (response.status) {
        this.allResult = response.data;
        // console.log('this.allResult :>> ', this.allResult);
      } else {
        this.allResult = [];
      }
    }, error => {
      // Handle errors
      this.allResult = [];
      console.error(error);
    });
  }
  finalIndex: number = 0;
  private liveApiMatch(): void {
    // change type 2 to 1 for live
    let url = '/thirdparty/gt20/get-tournament-match-list/' + this.matchService.tournamentId + '?type=1'; //live
    // let url = '/thirdparty/gt20/get-tournament-match-list/' + 323239 + '?type=1'; //demo 
    this.sub7 = this.matchService.makeApiRequest(url).subscribe((response: any) => {
      console.log('live response :>> ', response);
      if (response.status) {
        this.liveMatch = [];
        this.liveMatch = response.data;
        // this.finalIndex = 0;
      } else {
        this.liveMatch = [];
      }
    }, error => {
      // Handle errors
      this.liveMatch = [];
      console.error(error);
    });
  }
  actionLive(action, index: number) {
    if (action == 'decrement') {
      if (index != 0) {
        this.finalIndex = index - 1;
      }
    } else if (action == 'increment') {
      if (this.liveMatch.length > 0 && ((this.liveMatch.length - 1) != index)) {
        this.finalIndex = index + 1;
      }
    } else {
      // not requried
    }
  }
  goToLive(data: any) {
    console.log('data :>> ', data);
    this.router.navigate(['/live-score'],
      {
        queryParams: {
          matchId: data.match_id
        }
      })
  }
  formatDate(dateString: any): string {
    let date = new Date(dateString);
    return this.datePipe.transform(date, 'MMMM dd, yyyy');
  }
  transform(value: string): string {
    const words = value.split(' ');
    if (words.length > 1) {
      return words.map(word => word.charAt(0)).join('').toUpperCase();
    } else {
      return value.slice(0, 2).toUpperCase();
    }
  }
  private boundaryCount() {
    let url = '/thirdparty/gt20/get-tournament-boundary-count/' + this.matchService.tournamentId;
    this.sub8 = this.matchService.makeApiRequest(url).subscribe((resp: any) => {
      if (resp.status) {
        console.log('this.resp :>> ', resp);
        this.totalBoundaryCount = resp.data;
      } else {
        this.totalBoundaryCount = [];
      }
    }, error => {
      // Handle errors
      this.totalBoundaryCount = [];
      console.error(error);
    });
  }
  ngOnDestroy() {
    if (this.intervalTime) {
      clearInterval(this.intervalTime);
    }
    if (this.sub1) {
      this.sub1.unsubscribe();
    }
    if (this.sub2) {
      this.sub2.unsubscribe();
    }
    if (this.sub3) {
      this.sub3.unsubscribe();
    }
    if (this.sub4) {
      this.sub4.unsubscribe();
    }
    if (this.sub5) {
      this.sub5.unsubscribe();
    }
    if (this.sub6) {
      this.sub6.unsubscribe();
    }
    if (this.sub7) {
      this.sub7.unsubscribe();
    }
    if (this.sub8) {
      this.sub8.unsubscribe();
    }
    // this.productservices2 = this.server.getApi('G5').subscribe((res) => {
    //   this.allVideo = res.response;
    // }).unsubscribe();
    // this.productservices3 = this.server.getApi('G4').subscribe((res) => {
    //   this.allPhotos = res.response;
    // }).unsubscribe();
    // this.productservices = this.server.getApi('G2').subscribe((res) => {
    //   this.allNews = res.response;
    // }).unsubscribe();
    // if (this.countdown) {
    //   clearInterval(this.countdown);
    // }
  }
}
